export type FeedbackRegion = {
  id: number;
  name: string;
  hasNoStats?: boolean;
};

export const FEEDBACK_REGIONS: FeedbackRegion[] = [
    { "id": 2292, "name": "Ямало-Ненецкий автономный округ" },
    { "id": 2293, "name": "Мурманская область" },
    { "id": 2296, "name": "Ханты-Мансийский автономный округ — Югра" },
    { "id": 2297, "name": "Республика Марий Эл" },
    { "id": 2298, "name": "Кемеровская область — Кузбасс" },
    { "id": 2299, "name": "Алтайский край" },
    { "id": 2300, "name": "Республика Адыгея" },
    { "id": 2301, "name": "Республика Башкортостан" },
    { "id": 2302, "name": "Республика Бурятия" },
    { "id": 2303, "name": "Республика Алтай" },
    { "id": 2304, "name": "Республика Дагестан" },
    { "id": 2305, "name": "Республика Ингушетия" },
    { "id": 2306, "name": "Кабардино-Балкарская Республика" },
    { "id": 2307, "name": "Республика Калмыкия" },
    { "id": 2308, "name": "Карачаево-Черкесская Республика" },
    { "id": 2309, "name": "Республика Карелия" },
    { "id": 2310, "name": "Республика Коми" },
    { "id": 2311, "name": "Республика Мордовия" },
    { "id": 2312, "name": "Республика Саха (Якутия)" },
    { "id": 2313, "name": "Республика Северная Осетия — Алания" },
    { "id": 2314, "name": "Республика Татарстан (Татарстан)" },
    { "id": 2315, "name": "Республика Тыва" },
    { "id": 2316, "name": "Удмуртская Республика" },
    { "id": 2317, "name": "Республика Хакасия" },
    { "id": 2318, "name": "Чеченская Республика" },
    { "id": 2319, "name": "Чувашская Республика — Чувашия" },
    { "id": 2320, "name": "Краснодарский край" },
    { "id": 2321, "name": "Красноярский край" },
    { "id": 2322, "name": "Приморский край" },
    { "id": 2323, "name": "Ставропольский край" },
    { "id": 2324, "name": "Хабаровский край" },
    { "id": 2325, "name": "Амурская область" },
    { "id": 2326, "name": "Архангельская область" },
    { "id": 2327, "name": "Астраханская область" },
    { "id": 2328, "name": "Белгородская область" },
    { "id": 2329, "name": "Брянская область" },
    { "id": 2330, "name": "Владимирская область" },
    { "id": 2331, "name": "Волгоградская область" },
    { "id": 2332, "name": "Вологодская область" },
    { "id": 2333, "name": "Воронежская область" },
    { "id": 2334, "name": "Ивановская область" },
    { "id": 2335, "name": "Иркутская область" },
    { "id": 2336, "name": "Калининградская область" },
    { "id": 2337, "name": "Калужская область" },
    { "id": 2338, "name": "Камчатский край" },
    { "id": 2339, "name": "Кировская область" },
    { "id": 2340, "name": "Костромская область" },
    { "id": 2341, "name": "Курганская область" },
    { "id": 2342, "name": "Курская область" },
    { "id": 2343, "name": "Ленинградская область" },
    { "id": 2344, "name": "Липецкая область" },
    { "id": 2345, "name": "Магаданская область" },
    { "id": 2346, "name": "Московская область" },
    { "id": 2347, "name": "Нижегородская область" },
    { "id": 2348, "name": "Новгородская область" },
    { "id": 2349, "name": "Новосибирская область" },
    { "id": 2350, "name": "Омская область" },
    { "id": 2351, "name": "Оренбургская область" },
    { "id": 2352, "name": "Орловская область" },
    { "id": 2353, "name": "Пензенская область" },
    { "id": 2354, "name": "Пермский край" },
    { "id": 2355, "name": "Псковская область" },
    { "id": 2356, "name": "Ростовская область" },
    { "id": 2357, "name": "Рязанская область" },
    { "id": 2358, "name": "Самарская область" },
    { "id": 2359, "name": "Саратовская область" },
    { "id": 2360, "name": "Сахалинская область" },
    { "id": 2361, "name": "Свердловская область" },
    { "id": 2362, "name": "Смоленская область" },
    { "id": 2363, "name": "Тамбовская область" },
    { "id": 2364, "name": "Тверская область" },
    { "id": 2365, "name": "Томская область" },
    { "id": 2366, "name": "Тульская область" },
    { "id": 2367, "name": "Тюменская область" },
    { "id": 2368, "name": "Ульяновская область" },
    { "id": 2369, "name": "Челябинская область" },
    { "id": 2370, "name": "Забайкальский край" },
    { "id": 2371, "name": "Ярославская область" },
    { "id": 2372, "name": "Санкт-Петербург" },
    { "id": 2373, "name": "Еврейская автономная область" },
    { "id": 2374, "name": "Ненецкий автономный округ" },
    { "id": 2375, "name": "Чукотский автономный округ" },
    { "id": 2376, "name": "Республика Крым" },
    { "id": 2377, "name": "Севастополь" },
    { "id": 2556, "name": "Москва" },
    { "id": 2092, "name": "Донецкая Народная Республика", "hasNoStats": true },
    { "id": 2093, "name": "Луганская Народная Республика", "hasNoStats": true },
    { "id": 2094, "name": "Запорожская область", "hasNoStats": true },
    { "id": 2095, "name": "Херсонская область", "hasNoStats": true },
];
